export default "__VITE_ASSET__C6cD0WP6__"